// @apps-common/config/theme.ts

import type { PortalThemeModel, ThemePayload } from '@apps-common/types/portal/theme'

export const THEME_NO_IMG_VALUE = 'na'

export enum ThemeMode {
  system = 'system',
  light = 'light',
  dark = 'dark'
}

/**
 * Boot theme used before auth / before tenant theme loads.
 * Keep this visually neutral and “Radionet branded”.
 */
export const DEFAULT_PALETTES: ThemePayload = {
  light: {
    // Brand
    logoBg: '#EEF3FB',
    brand: '#3B6FF6', // calm Radionet blue
    onBrand: '#FFFFFF',

    // Surfaces
    bg: '#F6F8FC', // page background (slight blue tint)
    surface: '#FFFFFF', // cards, panels
    surface2: '#F4F6FA', // inner cards / “inset” blocks
    border: '#E2E7F0',

    // Text
    text: '#121826',
    textMuted: '#5B6575',

    // UI
    focus: '#3B6FF6',
    disabledBg: '#E7ECF5',
    disabledText: '#8A94A6',

    // Status (pastel)
    success: '#7EDFB2',
    onSuccess: '#155F3E',
    warning: '#FFD28A',
    onWarning: '#7A4B00',
    error: '#F6A6A6',
    onError: '#7A1C1C',
    info: '#A8C9FF',
    onInfo: '#0E3A8A',

    // Logos / MM
    myMonitoringLogoBg: '#F1F5FB',
    myMonitoringBrand: '#0A8CFF',
    onMyMonitoringBrand: '#F8FAFC',
    myMonitoringBrand2: '#14C7C8',
    onMyMonitoringBrand2: '#F8FAFC'
  },
  dark: {
    // Brand
    logoBg: '#0E1729',
    brand: '#6C8DFF', // brighter than light brand so it reads on dark
    onBrand: '#0B1020',

    // Surfaces
    bg: '#0B1020', // page background
    surface: '#101A2E', // cards
    surface2: '#121F36', // inset / inner
    border: '#1E2B45',

    // Text (no pure white)
    text: '#E7EAF0',
    textMuted: '#9AA3B2',

    // UI
    focus: '#93ABFF',
    disabledBg: '#1A2338',
    disabledText: '#6F7A90',

    // Status (deeper)
    success: '#2E7D5B',
    onSuccess: '#BFF3DA',
    warning: '#9C6A1E',
    onWarning: '#FFE3B0',
    error: '#8A2F2F',
    onError: '#F6BABA',
    info: '#2E4E8F',
    onInfo: '#C6DAFF',

    // Logos / MM
    myMonitoringLogoBg: '#0C1424',
    myMonitoringBrand: '#0A8CFF',
    onMyMonitoringBrand: '#F8FAFC',
    myMonitoringBrand2: '#14C7C8',
    onMyMonitoringBrand2: '#F8FAFC'
  }
}

/**
 * Default theme model shape that matches the backend new schema.
 * NOTE: palettesJson is what the DB stores; palettes is convenient for the frontend.
 */
export const DEFAULT_THEME: PortalThemeModel = {
  id: -1,
  themeId: 'default',
  companyId: '',
  themeUpdatedUserId: -1,
  themeUpdatedUsername: 'System',
  themeUpdatedTimestamp: '2024-06-01',
  themeSchemaVersion: 2,
  palettesJson: JSON.stringify(DEFAULT_PALETTES),
  palettes: DEFAULT_PALETTES
}
